import { useRuntimeConfigKey, type UseRuntimeConfig } from '@/injectionKeys';
import { buildOptimizedImageUrl, type OptimizeImageOptions } from '@/wabunka-src/common/utils/image/imageOptimizer';

/**
 * 最適化済み画像 URL を生成する関数を返すコンポーザブル。
 *
 * runtimeConfig の inject は **setup（コンポーネントの同期セットアップ）コンテキストでのみ解決できる**ため、
 * ここで一度だけ解決し、以降は inject 不要な純粋関数（{@link buildOptimizedImageUrl}）を返す。
 * これにより、返した関数を computed 内で呼んでも安全
 * （computed の再評価がレンダリング外で走っても inject を踏まないため、`useRuntimeConfig is not a function` による 500 が起きない）。
 *
 * @example
 * const getOptimizedImageUrl = useOptimizedImageUrl(); // setup で呼ぶ
 * const url = computed(() => getOptimizedImageUrl(props.imageUrl, { width: 560 }));
 */
export const useOptimizedImageUrl = (): ((originalUrl: string, options?: OptimizeImageOptions) => string) => {
  const useRuntimeConfig = inject(useRuntimeConfigKey) as UseRuntimeConfig;
  const runtimeConfig = useRuntimeConfig();
  return (originalUrl: string, options: OptimizeImageOptions = {}): string => buildOptimizedImageUrl(runtimeConfig.public, originalUrl, options);
};
